import axios from '../../../../services/axios';

export function getActivityLog(params) {
  return axios.get('/api/dashboard/activity-log', params);
}
